import { defineStore } from 'pinia'
import { ref } from 'vue'

/**
 * Holds the most recent unexpected/server error so {@code ErrorView} can render its detail. Set by
 * the global {@code app.config.errorHandler} (main.ts) when an uncaught error (e.g. a 5xx from an
 * API call a view didn't handle) bubbles up; cleared when the user leaves the error page. The detail
 * is only ever shown to admins — see ErrorView.
 */
export const useAppErrorStore = defineStore('appError', () => {
  const status = ref<number | null>(null)
  const message = ref<string>('')

  function set(nextStatus: number | null, nextMessage: string): void {
    status.value = nextStatus
    message.value = nextMessage
  }

  function clear(): void {
    status.value = null
    message.value = ''
  }

  return { status, message, set, clear }
})
